const config={
  purchase:{
    api:{
      payment: '/api/payments',
    },
    fields: {
      date: {
        name: "date",
        label: "ご希望の日程",
        options: {
          rules: [{
            required: true,
            message: 'ご希望の日程を選択してください',
          }],
        }
      },
      time: {
        name: "time",
        label: "ご希望の出発時間",
        options: {
          rules: [{
            required: true,
            message: 'ご希望の出発時間を選択してください',
          }],
        }
      },
      noa: {
        name: "noa",
        label: "参加人数",
        options: {
          /*
          rules: [{
            required: true,
            message: '参加人数を追加して下さい',
          }],
          */
        }
      },
      noc: {
        name: "noc",
        label: "参加人数",
        options: {
        }
      },
      flight: {
        name: "flight",
        label: "フライトは取得済みですか?",
        options: {
        },
        items: [
          {key: 'yes',  label: '購入済み'},
          {key: 'no',   label: '未購入'},
          {key: 'quote',label: '見積もり依頼'},
        ]
      },
      flight_info: {
        name: "flight_info",
        label: "もしフライト番号をご存知でしたらご記入ください。今わからない場合は、後日メールにてお知らせください。例：ウルルへ8月1日JQ660 / 戻り8月3日JQ661など。",
        options: {
        }
      },
      flight_quote_in: {
        name: "flight_quote_in",
        label: "往路（出発する都市）",
        options: {},
        items: [
          {key: 'sydney', label: 'シドニー'},
          {key: 'melbourne', label: 'メルボルン'},
          {key: 'cairns', label: 'ケアンズ'},
          {key: 'brisbane', label: 'ブリスベン'},
          {key: 'goldcoast', label: 'ゴールドコースト'},
          {key: 'perth', label: 'パース'},
          {key: 'adelaide', label: 'アデレード'},
          {key: 'hobart', label: 'ホバート'},
          {key: 'launceston', label: 'ローンセストン'},
        ]
      },
      flight_quote_out: {
        name: "flight_quote_out",
        label: "復路（戻る都市）",
        options: {},
        items: [
          {key: 'sydney', label: 'シドニー'},
          {key: 'melbourne', label: 'メルボルン'},
          {key: 'cairns', label: 'ケアンズ'},
          {key: 'brisbane', label: 'ブリスベン'},
          {key: 'goldcoast', label: 'ゴールドコースト'},
          {key: 'perth', label: 'パース'},
          {key: 'adelaide', label: 'アデレード'},
          {key: 'hobart', label: 'ホバート'},
          {key: 'launceston', label: 'ローンセストン'},
        ]
      },
      accommodation: {
        name: "accommodation",
        label: "もし宿泊先をご存知でしたらご記入ください",
        options: {
        },
        items: [
          {key: 'yes',  label: '手配済み'},
          {key: 'no',   label: '未手配'},
          {key: 'quote',label: '見積もり依頼'},
        ]
      },
      accommodation_info: {
        name: "accommodation_info",
        label: "宿泊先をご選択ください",
        options: {
        },
        items: [
          {key: 'TBA', label: '後で知らせる'},
          {key: 'Outback Pioneer Lodge', label: 'Outback Pioneer Lodge'},
          {key: 'Desert Garden Hotel', label: 'Desert Garden Hotel'},
          {key: 'Sales In The Desert', label: 'Sales In The Desert'},
          {key: 'Emu Walk Apartment', label: 'Emu Walk Apartment'},
          {key: 'The Lost Camel', label: 'The Lost Camel'},
        ]
      },
      accommodation_quote: {
        name: "accommodation_quote",
        label: "お見積り希望のご宿泊先をご選択ください",
        options: {
        },
        items: [
          {key: 'TBA', label: '後で知らせる'},
          {key: 'Outback Pioneer 20人部屋 $38/人', label: 'Outback Pioneer 20人部屋 $38/人'},
          {key: 'Outback Pioneer 4人部屋 $46/人', label: 'Outback Pioneer 4人部屋 $46/人'},
          {key: 'Outback Pioneer Hotel $350-$390/泊', label: 'Outback Pioneer Hotel $350-$390/泊'},
          {key: 'Lost Camel Hotel $390-$460/泊', label: 'Lost Camel Hotel $390-$460/泊'},
          {key: 'Desert Garden Hotel $470-$550/泊', label: 'Desert Garden Hotel $470-$550/泊'},
          {key: 'Sails in the desert $560-$680/泊', label: 'Sails in the desert $560-$680/泊'},
          {key: 'Emu Walk Apartment $485-$575/泊', label: 'Emu Walk Apartment $485-$575/泊'},
        ]
      },
      pickup: {
        name: "pickup",
        label: "現地ご滞在先",
        options: {
        },
        items: [
          {key: 'hotel',  label: 'ホテル'},
          {key: 'local',  label: '現地在住'},
          {key: 'notsure',label: '未定'},
        ]
      },
      pickup_hotel: {
        name: "pickup_hotel",
        label: "滞在ホテル名を入力してください",
        options: {
        },
      },
      pickup_local: {
        name: "pickup_local",
        label: "現地滞在方法を入力してください",
        options: {
        },
      },
      gender: {
        name: "gender",
        label: "性別",
        options: {
          rules: [{
            required: true,
            message: 'どちらかを選択してください',
          }],
        },
        items: [
          {key: 'male',  label: 'Mr'},
          {key: 'female', label: 'Ms'},
        ]
      },
      last_name: {
        name: "last_name",
        label: "姓 (Yamada)",
        options: {
          rules: [{
            required: true,
            message: 'お名前を入力してください',
          }],
        }
      },
      first_name: {
        name: "first_name",
        label: "名 (Taro)",
        options: {
          rules: [{
            required: true,
            message: 'お名前を入力してください',
          }],
        }
      },
      dob: {
        name: "dob",
        label: "生年月日 (2017-12-30)",
        options: {
          rules: [{
            required: true,
            message: '生年月日を入力してください',
          }],
        }
      },
      email: {
        name: "email",
        label: "Eメールアドレス",
        options: {
//          initialValue: 'ken@dimio.net',
//          validateFirst:false,
//          trigger: 'onSubmit',
//          trigger: 'onBlur',
          rules: [{
            type: 'email',
            message: '有効なEmailを入力してください',
          }, {
            required: true,
            message: 'Emailを入力してください',
          }],
        }
      },
      phone: {
        name: "phone",
        label: "メールが届かなかった場合の連絡先電話番号",
        options: {
        }
      },
      enquiry: {
        name: "enquiry",
        label: "お問合わせ",
        options: {

        }
      },
      recurring: {
        name: "recurring",
        label: "recurring",
        options: {}
      },
      address: {
        name: "address",
        label: "住所",
        options: {}
      },
      state: {
        name: "state",
        label: "State",
        options: {},
        items: [
          {key: 'nsw', label: 'NSW'},
          {key: 'qld', label: 'QLD'},
          {key: 'vic', label: 'VIC'},
        ]
      },
      postcode: {
        name: "postcode",
        label: "Postcode",
        options: {
          rules: [{
            required: true,
            message: 'Please input postcode',
          }],
        }
      },
      payment: {
        name: "payment",
        label: "カード情報",
        options: {},
      },
    },
    stripeStyle:{
      base: {
        color: '#303238',
        fontSize: '18px',
        lineHeight: '52px',
        fontSmoothing: 'antialiased',
        '::placeholder': {
          color: '#ccc',
        },
      },
      empty: {
        color: '#e5424d',
        ':focus': {
          color: '#303238',
        },
        '::placeholder': {
          color: '#e5424d',
        },
      },
      invalid: {
        color: '#e5424d',
        ':focus': {
          color: '#303238',
        },
        '::placeholder': {
          color: '#e5424d',
        },
      },
    }
  },
};

export default config;



// WEBPACK FOOTER //
// ./src/pages/purchase/config/config.js